import { schoolsSlice } from "./slice";

export const { setSelectedSession, resetSchoolSlice, setSessionMonth } =
  schoolsSlice.actions;
